import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
@Injectable()
export class MyFilterPipe implements PipeTransform {
  transform(items: any[], args: any[]): any {
    args.toString().toLowerCase();
    return items.filter(item => item.toString().toLowerCase().indexOf(args) > -1);
  }
}

@Pipe({
  name: 'vehicleGroupListFilter'
})
@Injectable()
export class VehicleGroupListFilter implements PipeTransform {
  transform(items: any[], args: any[]): any {
    let _args:string = args.toString().toLowerCase();
    let newArray = [];
    let empty: any = '';
    let object;
    function getRegistration(matrix) {
      let flag: boolean;
      let counter: number;
      for(let i=0; i<matrix.length; i++) {
        counter = 0;
        flag = false;
        object = '';
        for (let j=0; j<matrix[i].vehicles.length; j++) {
          counter++;
          if (_args != empty && matrix[i].vehicles[j].registration.toString().toLowerCase().indexOf(_args) > -1) {
            if (flag == false) {
              object = Object.assign({}, matrix[i]);
              object.vehicles = [];
              flag = true;
            }
            object.vehicles.push(matrix[i].vehicles[j]);
          }
          if (counter == matrix[i].vehicles.length && flag == true) {
            newArray.push(object);
          }
        }
      }
      if (args == empty) {
       return matrix;
      } else {
       return newArray;
      }
    }
    return getRegistration(items);
  }
}

@Pipe({
  name: 'driverGroupListFilter'
})
@Injectable()
export class DriverGroupListFilter implements PipeTransform {
  transform(items: any[], args: any[]): any {
    let _args:string = args.toString().toLowerCase();
    let newArray = [];
    let empty: any = '';
    let object;
    function getRegistration(matrix) {
      let flag: boolean;
      let counter: number;
      console.log(matrix);
      for(let i=0; i<matrix.length; i++) {
        counter = 0;
        flag = false;
        object = '';
        console.log(matrix[i]);
        for (let j=0; j<matrix[i].drivers.length; j++) {
          counter++;
          if (_args != empty && matrix[i].drivers[j].first_name.toString().toLowerCase().indexOf(_args) > -1) {
            if (flag == false) {
              object = Object.assign({}, matrix[i]);
              object.drivers = [];
              flag = true;
            }
            object.drivers.push(matrix[i].drivers[j]);
          }
          if (counter == matrix[i].drivers.length && flag == true) {
            newArray.push(object);
          }
        }
      }
      if (args == empty) {
        return matrix;
      } else {
        return newArray;
      }
    }
    return getRegistration(items);
  }
}

@Pipe({
  name: 'vehicleSubSetGroupListFilter'
})
@Injectable()
export class vehicleSubSetGroupListFilter implements PipeTransform {
  transform(items: any[], args: any[]): any {
    let _args:string = args.toString().toLowerCase();
    let newArray = [];
    let empty: any = '';
    let object;
    function getRegistration(matrix) {
      let flag: boolean;
      let counter: number;
      for(let i=0; i<matrix.length; i++) {
        counter = 0;
        flag = false;
        object = '';
        for (let j=0; j<matrix[i].vehicles_subset.length; j++) {
          counter++;
          if (_args != empty && matrix[i].vehicles_subset[j].registration.toString().toLowerCase().indexOf(_args) > -1) {
            if (flag == false) {
              object = Object.assign({}, matrix[i]);
              object.vehicles_subset = [];
              flag = true;
            }
            object.vehicles_subset.push(matrix[i].vehicles_subset[j]);
          }
          if (counter == matrix[i].vehicles_subset.length && flag == true) {
            newArray.push(object);
          }
        }
      }
      if (args == empty) {
       return matrix;
      } else {
       return newArray;
      }
    }
    return getRegistration(items);
  }
}

@Pipe({
  name: "orderBy",
  pure: false
})
export class ArraySortPipe {
  transform(array: any[], field: string): any[] {
    if (array !== undefined) {
      array.sort((a: any, b: any) => {
        if (a[field] < b[field]) {
          return -1;
        } else if (a[field] > b[field]) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return array;
  }
}

// This filter is to remove any vehicles that shouldn't be displayed on the map
@Pipe({
  name: "uniqueVehicleListFilter",
  pure: false
})
export class uniqueVehicleListFilter {
  transform(items: any[], args: any[]): any {
    let newArray = [];

    function getActiveVehicles(matrix) {
      for (let i = 0; i < matrix.length; i++) {
        if (matrix[i].activeGroups.length > 0) {
          newArray.push(matrix[i]);
        }
      }
      return newArray;
    }

    return getActiveVehicles(items);
  }
}

@Pipe({
  name: 'newVehicleGroupListFilter'
})
@Injectable()
export class NewVehicleGroupListFilter implements PipeTransform {
  transform(items: any[], args: any[]): any {
    let _args:string = args.toString().toLowerCase();
    let newArray = [];
    let empty: any = '';
    let object;


    function getRegistration(matrix) {
      let flag: boolean;
      let counter: number;
      for(let i=0; i<matrix.length; i++) {
        counter = 0;
        flag = false;
        object = '';

        if (_args != empty && matrix[i].name.toString().toLowerCase().indexOf(_args) > -1) {

          let tempVehicleGroup = JSON.parse(JSON.stringify(matrix[i]));
          tempVehicleGroup.name = tempVehicleGroup.name.replace(new RegExp(_args, "gi"), match => {
            return '<span class="highlightText">' + match + '</span>';
          });
          object = Object.assign({},tempVehicleGroup);
          object.vehicles = [];
          flag = true;
        }



        for (let j=0; j<matrix[i].vehicles.length; j++) {
          counter++;
          if (_args != empty && matrix[i].vehicles[j].registration.toString().toLowerCase().indexOf(_args) > -1) {
            if (flag == false) {
              object = Object.assign({}, matrix[i]);
              object.vehicles = [];
              flag = true;
            }
            // A quick & simple deep copy, link bellow. TODO possibly replacee with a custom deep copy for more speed
            // https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript/5344074#5344074
            let stringTempVehicle = JSON.stringify(matrix[i].vehicles[j]);
            let tempvehicle = JSON.parse(stringTempVehicle);
            tempvehicle.registration = tempvehicle .registration.replace(new RegExp(_args, "gi"), match => {
              return '<span class="highlightText">' + match + '</span>';
            });
            object.vehicles.push(tempvehicle);
          }
          if (counter == matrix[i].vehicles.length && flag == true) {
            newArray.push(object);
          }
        }
      }
      if (args == empty) {
        return matrix;
      } else {
        return newArray;
      }
    }
    return getRegistration(items);
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/filter.service.ts